import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { styled } from "styled-components";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
// import { ClassNames } from "@emotion/react";


const WorkoutVideo = () => {
  const arr = useSelector((state) => state.excercisereducer.excercise);
  const { id } = useParams();
  let arr1 = arr.filter((item) => item._id === id);
  let obj = arr1[0];
  console.log(obj)
  const navigate = useNavigate()

  const token = useSelector((store) => store.authreducer.token)
  const location = useLocation();
  const itemData = location.state?.itemData || {}
  // console.log(itemData,"itemdata")


  const {
    description,
    duration,
    img,
    name,
    repetition,
    sets,
    type,
    video,

  } = itemData




  // console.log(video,"video")

  //want to extract the video id from the video link
  let videoId
  let video1

  if (video) {
    console.log(video)
    video1 = new URL(itemData.video).searchParams.get("v")
  }else{
    videoId =  new URL(obj.video).searchParams.get("v")
  }





  const addtodiary = () => {

   


    let obj2 = {
      name: name || obj.name,
      description: description || obj.description,
      duration: duration || obj.duration,
      img: img || obj.img,
      repetition: repetition || obj.repetition,
      sets: sets || obj.sets,
      type: type || obj.type,
      video: video || obj.video
    }



    fetch("https://fitness-park.onrender.com/fitness/diary", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
      body: JSON.stringify(obj2),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(async (data) => {
        // Handle the response data here
        console.log('Response:', data);

        // Show SweetAlert2 success message and wait for user confirmation
        await Swal.fire(
          'Good job!',
          'Exercise Added to Diary',
          'success'
        );

        // Once the user clicks "OK" on SweetAlert2, navigate to '/dashboard'
        navigate('/dashboard');
      })
      .catch((error) => {
        // Handle errors here
        console.error('Error:', error);
      });


  }



  return (
    <DIV>
      <div id="frame">


  
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube-nocookie.com/embed/${video1||videoId}`}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
  

        <div id="info">
          <table>
            <tr>
              <td>Duration</td>
              <td>{duration || obj.duration}</td>
            </tr>
            <tr>
              <td>Repetition</td>
              <td>{repetition || obj.repetition}</td>
            </tr>
            <tr>
              <td>Sets</td>
              <td>{sets || obj.sets}</td>
            </tr>
          </table>
          <button onClick={addtodiary}>Add The excerise to your workout</button>
        </div>
      </div>
      <div className="name_desc">
        <h1>{name || obj.name}</h1>
        <p className="desc">{description || obj.description}</p>
      </div>
    </DIV>
  );
};

const DIV = styled.div`
  /* height: 100vh; */
  padding: 20px;
  padding-top: 60px;
  #frame {
    display: grid;
    grid-template-columns: 3fr 1fr;
    /* width: 80%; */
    margin-bottom: 10px;
    /* border: 1px solid red; */
    column-gap: 10px;
  }
  iframe {
    width: 130vh;
    height: 70vh;
  }
  h1 {
    text-align: left;
  }
  p {
    text-align: left;
  }
  button {
    width: 100%;
    height: 50px;
    font-weight: 600;
    text-transform: uppercase;
    -webkit-transition: all 200ms linear;
    transition: all 200ms linear;
    padding: 0 30px;
    letter-spacing: 1px;
    display: -webkit-inline-flex;
    display: -ms-inline-flexbox;
    display: inline-flex;
    align-items: center;
    background-color: #ffeba7;
    color: #000000;
    border: none;
    margin-top: 20px;
  }
  button:hover {
    background-color: #131329;
    color: white;
    color: #ffeba7;
    box-shadow: 0 8px 24px 0 rgba(16, 39, 112, 0.2);
    border: none;
  }
  #info table {
    text-align: center;
    font-size: 40px;
    text-align: left;
    width: 100%;
  }
  tr {
    border: 3px solid black;
  }
  td {
    border: 3px solid black;
    padding: 10px;
  }

  #frame{
    padding-top: 60px;
  
  }

  .name_desc{
    /* border: 3px solid red; */
    width:65%;

  }

  .desc{
    padding-top: 10px;
   font-size: 20px;
   padding-bottom: 30px;
   text-align: start;
   
  }
`;
export default WorkoutVideo;
